import React from 'react';
import SectionWrapper from '../layout/SectionWrapper';
import SkillsTabs from './SkillsTabs';

export default function Skills() {
  return (
<SectionWrapper id="skills" className="relative bg-black/20 backdrop-blur-md border-t border-white/10 py-28">

      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl sm:text-5xl font-bold font-geist tracking-tight text-white text-center mb-10">
          Skills
        </h2>
        <SkillsTabs />
      </div>
    </SectionWrapper>
  );
}
